
export enum LegalizationDocumentStatusEnum {
    ToBeVerified = 1,
    RequiresCorrection = 2,
    Valid = 3,
    Corrected = 4
}